// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionImageController from "./accordion_image_controller"
application.register("accordion-image", AccordionImageController)

import CelebrateController from "./celebrate_controller"
application.register("celebrate", CelebrateController)

import FaqSuggestionsController from "./faq_suggestions_controller"
application.register("faq-suggestions", FaqSuggestionsController)

import AgeRestrictionsController from "./age_restrictions_controller"
application.register("age-restrictions", AgeRestrictionsController)

import AiMenuController from "./ai_menu_controller"
application.register("ai-menu", AiMenuController)

import SgDropdownController from "./sg_dropdown_controller"
application.register("sg-dropdown", SgDropdownController)

import ApplyDiscountController from "./apply_discount_controller"
application.register("apply-discount", ApplyDiscountController)

import AttendeeDatatableController from "./attendee_datatable_controller"
application.register("attendee-datatable", AttendeeDatatableController)

import ResponsesDatatableController from "./responses_datatable_controller"
application.register("responses-datatable", ResponsesDatatableController)

import AttendanceTabsController from "./attendance_tabs_controller"
application.register("attendance-tabs", AttendanceTabsController)

import AttendanceDayController from "./attendance_day_controller"
application.register("attendance-day", AttendanceDayController)

import AttendeeMobileNavController from "./attendee_mobile_nav_controller"
application.register("attendee-mobile-nav", AttendeeMobileNavController)

import AutoDismissController from "./auto_dismiss_controller"
application.register("auto-dismiss", AutoDismissController)

import AuditTrailDatatableController from "./audit_trail_datatable_controller"
application.register("audit-trail-datatable", AuditTrailDatatableController)

import BioExpanderController from "./bio_expander_controller"
application.register("bio-expander", BioExpanderController)

import CampaignDatatableController from "./campaign_datatable_controller"
application.register("campaign-datatable", CampaignDatatableController)

import CampaignRecipientsDatatableController from "./campaign_recipients_datatable_controller"
application.register("campaign-recipients-datatable", CampaignRecipientsDatatableController)

import CampaignWizardController from "./campaign_wizard_controller"
application.register("campaign-wizard", CampaignWizardController)

import CampaignAiController from "./campaign_ai_controller"
application.register("campaign-ai", CampaignAiController)

import EventCardToggleController from "./event_card_toggle_controller"
application.register("event-card-toggle", EventCardToggleController)

import FileUploadFieldController from "./file_upload_field_controller"
application.register("file-upload-field", FileUploadFieldController)

import EmailDeviceController from "./email_device_controller"
application.register("email-device", EmailDeviceController)

import CampaignDeliveryController from "./campaign_delivery_controller"
application.register("campaign-delivery", CampaignDeliveryController)

import CancelSubeventWizardController from "./cancel_subevent_wizard_controller"
application.register("cancel-subevent-wizard", CancelSubeventWizardController)

import ChartRefreshController from "./chart_refresh_controller"
application.register("chart-refresh", ChartRefreshController)

import CheckoutTicketSelectController from "./checkout_ticket_select_controller"
application.register("checkout-ticket-select", CheckoutTicketSelectController)

import ContactDatatableController from "./contact_datatable_controller"
application.register("contact-datatable", ContactDatatableController)

import ContactFiltersController from "./contact_filters_controller"
application.register("contact-filters", ContactFiltersController)

import ContactsFiltersDrawerController from "./contacts_filters_drawer_controller"
application.register("contacts-filters-drawer", ContactsFiltersDrawerController)

import ContactEmailFormController from "./contact_email_form_controller"
application.register("contact-email-form", ContactEmailFormController)

import ContactGroupFormController from "./contact_group_form_controller"
application.register("contact-group-form", ContactGroupFormController)

import ContactImportController from "./contact_import_controller"
application.register("contact-import", ContactImportController)

import CopyTextController from "./copy_text_controller"
application.register("copy-text", CopyTextController)

import CopyPrimaryAttendeeController from "./copy_primary_attendee_controller"
application.register("copy-primary-attendee", CopyPrimaryAttendeeController)

import CollapsibleSummaryController from "./collapsible_summary_controller"
application.register("collapsible-summary", CollapsibleSummaryController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CountdownTimerController from "./countdown_timer_controller"
application.register("countdown-timer", CountdownTimerController)

import CountryStateController from "./country_state_controller"
application.register("country-state", CountryStateController)

import CreateOrganizationModalController from "./create_organization_modal_controller"
application.register("create-organization-modal", CreateOrganizationModalController)

import CustomizeUrlController from "./customize_url_controller"
application.register("customize-url", CustomizeUrlController)

import DashboardCustomizationController from "./dashboard_customization_controller"
application.register("dashboard-customization", DashboardCustomizationController)

import DashboardOrgModalController from "./dashboard_org_modal_controller"
application.register("dashboard-org-modal", DashboardOrgModalController)

import DatatableController from "./datatable_controller"
application.register("datatable", DatatableController)

import DateInputController from "./date_input_controller"
application.register("date-input", DateInputController)

import DateRangeFilterController from "./date_range_filter_controller"
application.register("date-range-filter", DateRangeFilterController)

import DateTimeBaseController from "./date_time_base_controller"
application.register("date-time-base", DateTimeBaseController)

import DateValidationController from "./date_validation_controller"
application.register("date-validation", DateValidationController)

import DeleteConfirmController from "./delete_confirm_controller"
application.register("delete-confirm", DeleteConfirmController)

import DiscountBundleListController from "./discount_bundle_list_controller"
application.register("discount-bundle-list", DiscountBundleListController)

import DiscountDatatableController from "./discount_datatable_controller"
application.register("discount-datatable", DiscountDatatableController)

import DiscountFormController from "./discount_form_controller"
application.register("discount-form", DiscountFormController)

import DiscountSalesTimingController from "./discount_sales_timing_controller"
application.register("discount-sales-timing", DiscountSalesTimingController)

import DiscountOperationController from "./discount_operation_controller"
application.register("discount-operation", DiscountOperationController)

import DonationAmountsController from "./donation_amounts_controller"
application.register("donation-amounts", DonationAmountsController)

import DonationTicketController from "./donation_ticket_controller"
application.register("donation-ticket", DonationTicketController)

import EarlyBirdPricingController from "./early_bird_pricing_controller"
application.register("early-bird-pricing", EarlyBirdPricingController)

import EventAboutController from "./event_about_controller"
application.register("event-about", EventAboutController)

import EventDatatableController from "./event_datatable_controller"
application.register("event-datatable", EventDatatableController)

import EventDateTimeController from "./event_date_time_controller"
application.register("event-date-time", EventDateTimeController)

import EventDatesShowController from "./event_dates_show_controller"
application.register("event-dates-show", EventDatesShowController)

import EventEditableController from "./event_editable_controller"
application.register("event-editable", EventEditableController)

import EventFieldController from "./event_field_controller"
application.register("event-field", EventFieldController)

import EventGraphController from "./event_graph_controller"
application.register("event-graph", EventGraphController)

import EventImageUploadController from "./event_image_upload_controller"
application.register("event-image-upload", EventImageUploadController)

import EventGalleryUploadController from "./event_gallery_upload_controller"
application.register("event-gallery-upload", EventGalleryUploadController)

import LightboxController from "./lightbox_controller"
application.register("lightbox", LightboxController)

import EventLinksController from "./event_links_controller"
application.register("event-links", EventLinksController)


import EventLocationController from "./event_location_controller"
application.register("event-location", EventLocationController)

import EventPerformanceChartController from "./event_performance_chart_controller"
application.register("event-performance-chart", EventPerformanceChartController)

import EventPlaceController from "./event_place_controller"
application.register("event-place", EventPlaceController)

import EventSettingController from "./event_setting_controller"
application.register("event-setting", EventSettingController)

import EventTagsController from "./event_tags_controller"
application.register("event-tags", EventTagsController)

import EventWidgetConfiguratorController from "./event_widget_configurator_controller"
application.register("event-widget-configurator", EventWidgetConfiguratorController)

import ExpandableSectionController from "./expandable_section_controller"
application.register("expandable-section", ExpandableSectionController)

import FieldErrorFocusController from "./field_error_focus_controller"
application.register("field-error-focus", FieldErrorFocusController)

import FeatureToggleController from "./feature_toggle_controller"
application.register("feature-toggle", FeatureToggleController)

import FinancialsDatatableController from "./financials_datatable_controller"
application.register("financials-datatable", FinancialsDatatableController)

import FlashMessageController from "./flash_message_controller"
application.register("flash-message", FlashMessageController)

import FormController from "./form_controller"
application.register("form", FormController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import FunnelSourceTabsController from "./funnel_source_tabs_controller"
application.register("funnel-source-tabs", FunnelSourceTabsController)

import GoogleMapController from "./google_map_controller"
application.register("google-map", GoogleMapController)


import HomeController from "./home_controller"
application.register("home", HomeController)

import HomeCustomListingController from "./home_custom_listing_controller"
application.register("home-custom-listing", HomeCustomListingController)

import HomeOrderDatatableController from "./home_order_datatable_controller"
application.register("home-order-datatable", HomeOrderDatatableController)

import HomeRegistrationDatatableController from "./home_registration_datatable_controller"
application.register("home-registration-datatable", HomeRegistrationDatatableController)

import HomePastEventDatatableController from "./home_past_event_datatable_controller"
application.register("home-past-event-datatable", HomePastEventDatatableController)

import HomeUpcomingEventDatatableController from "./home_upcoming_event_datatable_controller"
application.register("home-upcoming-event-datatable", HomeUpcomingEventDatatableController)

import HorizontalScrollController from "./horizontal_scroll_controller"
application.register("horizontal-scroll", HorizontalScrollController)

import ImageCropperController from "./image_cropper_controller"
application.register("image-cropper", ImageCropperController)

import CoverCropperController from "./cover_cropper_controller"
application.register("cover-cropper", CoverCropperController)

import TabConfigController from "./tab_config_controller"
application.register("tab-config", TabConfigController)

import ImageUploadBaseController from "./image_upload_base_controller"
application.register("image-upload-base", ImageUploadBaseController)

import ImageUploadController from "./image_upload_controller"
application.register("image-upload", ImageUploadController)

import InternalEventCategoryDatatableController from "./internal_event_category_datatable_controller"
application.register("internal-event-category-datatable", InternalEventCategoryDatatableController)

import InternalEventDatatableController from "./internal_event_datatable_controller"
application.register("internal-event-datatable", InternalEventDatatableController)

import InternalEventSubcategoryDatatableController from "./internal_event_subcategory_datatable_controller"
application.register("internal-event-subcategory-datatable", InternalEventSubcategoryDatatableController)

import InviteEventSelectController from "./invite_event_select_controller"
application.register("invite-event-select", InviteEventSelectController)

import InviteRoleController from "./invite_role_controller"
application.register("invite-role", InviteRoleController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import MarketingInsightsFilterController from "./marketing_insights_filter_controller"
application.register("marketing-insights-filter", MarketingInsightsFilterController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import ModalCleanupController from "./modal_cleanup_controller"
application.register("modal-cleanup", ModalCleanupController)

import ReloadOnCloseController from "./reload_on_close_controller"
application.register("reload-on-close", ReloadOnCloseController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NumberFieldController from "./number_field_controller"
application.register("number-field", NumberFieldController)

import OrderDatatableController from "./order_datatable_controller"
application.register("order-datatable", OrderDatatableController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import OrderSummaryController from "./order_summary_controller"
application.register("order-summary", OrderSummaryController)

import OrganizationCustomUrlController from "./organization_custom_url_controller"
application.register("organization-custom-url", OrganizationCustomUrlController)

import OrganizationDatatableController from "./organization_datatable_controller"
application.register("organization-datatable", OrganizationDatatableController)

import OrganizationEventController from "./organization_event_controller"
application.register("organization-event", OrganizationEventController)

import OrganizationOrderDatatableController from "./organization_order_datatable_controller"
application.register("organization-order-datatable", OrganizationOrderDatatableController)

import OrganizationWidgetConfiguratorController from "./organization_widget_configurator_controller"
application.register("organization-widget-configurator", OrganizationWidgetConfiguratorController)

import PaginationController from "./pagination_controller"
application.register("pagination", PaginationController)

import PanelActionsController from "./panel_actions_controller"
application.register("panel-actions", PanelActionsController)

import PasswordFormController from "./password_form_controller"
application.register("password-form", PasswordFormController)

import PasswordRequirementsController from "./password_requirements_controller"
application.register("password-requirements", PasswordRequirementsController)

import PasswordToggleController from "./password_toggle_controller"
application.register("password-toggle", PasswordToggleController)

import PersonalizedQuestionsController from "./personalized_questions_controller"
application.register("personalized-questions", PersonalizedQuestionsController)

import PricingCalculatorController from "./pricing_calculator_controller"
application.register("pricing-calculator", PricingCalculatorController)

import PromoCodeToggleController from "./promo_code_toggle_controller"
application.register("promo-code-toggle", PromoCodeToggleController)

import QuestionFormController from "./question_form_controller"
application.register("question-form", QuestionFormController)

import RecurrenceDatatableController from "./recurrence_datatable_controller"
application.register("recurrence-datatable", RecurrenceDatatableController)

import RedirectionManagerController from "./redirection_manager_controller"
application.register("redirection-manager", RedirectionManagerController)

import RefundFormController from "./refund_form_controller"
application.register("refund-form", RefundFormController)

import ResetTabsFieldsController from "./reset_tabs_fields_controller"
application.register("reset-tabs-fields", ResetTabsFieldsController)

import SalesChannelsAnimationController from "./sales_channels_animation_controller"
application.register("sales-channels-animation", SalesChannelsAnimationController)

import SavedVenuesController from "./saved_venues_controller"
application.register("saved-venues", SavedVenuesController)

import SectionImageUploadController from "./section_image_upload_controller"
application.register("section-image-upload", SectionImageUploadController)

import SessionCardsController from "./session_cards_controller"
application.register("session-cards", SessionCardsController)

import SimplePageAnimationController from "./simple_page_animation_controller"
application.register("simple-page-animation", SimplePageAnimationController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import StatToggleController from "./stat_toggle_controller"
application.register("stat-toggle", StatToggleController)

import StripePaymentController from "./stripe_payment_controller"
application.register("stripe-payment", StripePaymentController)

import SystemNotificationsController from "./system_notifications_controller"
application.register("system-notifications", SystemNotificationsController)

import TabBarController from "./tab_bar_controller"
application.register("tab-bar", TabBarController)

import TeamInvitationDatatableController from "./team_invitation_datatable_controller"
application.register("team-invitation-datatable", TeamInvitationDatatableController)


import MemberDetailTabsController from "./member_detail_tabs_controller"
application.register("member-detail-tabs", MemberDetailTabsController)

import MemberDrawerController from "./member_drawer_controller"
application.register("member-drawer", MemberDrawerController)

import TicketCarouselController from "./ticket_carousel_controller"
application.register("ticket-carousel", TicketCarouselController)

import TicketController from "./ticket_controller"
application.register("ticket", TicketController)

import TicketCountdownController from "./ticket_countdown_controller"
application.register("ticket-countdown", TicketCountdownController)

import TicketDiscountCalculatorController from "./ticket_discount_calculator_controller"
application.register("ticket-discount-calculator", TicketDiscountCalculatorController)

import TicketFeaturesAnimationController from "./ticket_features_animation_controller"
application.register("ticket-features-animation", TicketFeaturesAnimationController)

import TicketFormController from "./ticket_form_controller"
application.register("ticket-form", TicketFormController)

import TicketQuantityController from "./ticket_quantity_controller"
application.register("ticket-quantity", TicketQuantityController)

import TicketRowController from "./ticket_row_controller"
application.register("ticket-row", TicketRowController)

import TicketSalesTimingController from "./ticket_sales_timing_controller"
application.register("ticket-sales-timing", TicketSalesTimingController)

import TierNumberingController from "./tier_numbering_controller"
application.register("tier-numbering", TierNumberingController)

import TimeInputController from "./time_input_controller"
application.register("time-input", TimeInputController)

import TimeValidationController from "./time_validation_controller"
application.register("time-validation", TimeValidationController)

import TimezoneController from "./timezone_controller"
application.register("timezone", TimezoneController)

import TimezoneSelectController from "./timezone_select_controller"
application.register("timezone-select", TimezoneSelectController)

import ToggleBlockController from "./toggle_block_controller"
application.register("toggle-block", ToggleBlockController)

import TrixLinkDialogController from "./trix_link_dialog_controller"
application.register("trix-link-dialog", TrixLinkDialogController)

import ToggleCategoriesController from "./toggle_categories_controller"
application.register("toggle-categories", ToggleCategoriesController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import ToggleEventFrequencyController from "./toggle_event_frequency_controller"
application.register("toggle-event-frequency", ToggleEventFrequencyController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UpdateDatatableListingController from "./update_datatable_listing_controller"
application.register("update-datatable-listing", UpdateDatatableListingController)

import VideoBaseController from "./video_base_controller"
application.register("video-base", VideoBaseController)

import VideoPreviewController from "./video_preview_controller"
application.register("video-preview", VideoPreviewController)

import VideoUrlValidatorController from "./video_url_validator_controller"
application.register("video-url-validator", VideoUrlValidatorController)

import WaitlistDatatableController from "./waitlist_datatable_controller"
application.register("waitlist-datatable", WaitlistDatatableController)

import WidgetConfiguratorController from "./widget_configurator_controller"
application.register("widget-configurator", WidgetConfiguratorController)

import RedirectLoadingController from "./redirect_loading_controller"
application.register("redirect-loading", RedirectLoadingController)

import AddToCalendarController from "./add_to_calendar_controller"
application.register("add-to-calendar", AddToCalendarController)

import OnboardingChoiceController from "./onboarding_choice_controller"
application.register("onboarding-choice", OnboardingChoiceController)

import OnboardingDetailsController from "./onboarding_details_controller"
application.register("onboarding-details", OnboardingDetailsController)

import TimeSelectController from "./time_select_controller"
application.register("time-select", TimeSelectController)

import AttendanceDaysPreviewController from "./attendance_days_preview_controller"
application.register("attendance-days-preview", AttendanceDaysPreviewController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import TicketCheckInController from "./ticket_check_in_controller"
application.register("ticket-check-in", TicketCheckInController)

import AttendanceController from "./attendance_controller"
application.register("attendance", AttendanceController)

import CheckInCountdownController from "./check_in_countdown_controller"
application.register("check-in-countdown", CheckInCountdownController)

import CheckInSummaryController from "./check_in_summary_controller"
application.register("check-in-summary", CheckInSummaryController)

import ShareTicketsController from "./share_tickets_controller"
application.register("share-tickets", ShareTicketsController)

import SelfCheckInController from "./self_check_in_controller"
application.register("self-check-in", SelfCheckInController)

import AttendanceProgressController from "./attendance_progress_controller"
application.register("attendance-progress", AttendanceProgressController)

import ScheduleListController from "./schedule_list_controller"
application.register("schedule-list", ScheduleListController)

import CommHistoryController from "./comm_history_controller"
application.register("comm-history", CommHistoryController)

import NameSuggestionsController from "./name_suggestions_controller"
application.register("name-suggestions", NameSuggestionsController)

import SubeventBulkGenerateController from "./subevent_bulk_generate_controller"
application.register("subevent-bulk-generate", SubeventBulkGenerateController)

import PollFrameController from "./poll_frame_controller"
application.register("poll-frame", PollFrameController)

import ReportsController from "./reports_controller"
application.register("reports", ReportsController)

import ReportsTrendController from "./reports_trend_controller"
application.register("reports-trend", ReportsTrendController)

import OverviewSalesChartController from "./overview_sales_chart_controller"
application.register("overview-sales-chart", OverviewSalesChartController)

import OverviewRegistrationsChartController from "./overview_registrations_chart_controller"
application.register("overview-registrations-chart", OverviewRegistrationsChartController)

import ChatWidgetOffsetController from "./chat_widget_offset_controller"
application.register("chat-widget-offset", ChatWidgetOffsetController)
